class SearchFilterCategory extends HTMLElement {
    constructor(){
        super();
    }

    connectedCallback() {
        const filterObj = window.search_filterMeta;
        const sortedFilters = filterObj.sort((a, b) =>{
            return a.filter_order_position - b.filter_order_position;
        })
 
        this.render(sortedFilters);
    }

    renderCollectionList(list) {
        const collectionListContent = list.map((item) => {
            return `
            <li class="splide__slide link-item">
                <a href="${item.url}" style="margin-left: 8px"> ${item.title} </a>
            </li>`;
        })
        return collectionListContent.join('');
    }
      
    render(filters) {
        const UL_FILTER_MAX_WIDTH = 385;
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = '16px Arial'; 
        
      const content = filters.map( (filter) => {
            const collectionFilters = filter.collections_filters_list;
            const ulTextLength = collectionFilters.reduce((acc, item) => {
                return acc + context.measureText(item.title).width;  
            }, 0);

            const applySpliderArrow = ulTextLength <= UL_FILTER_MAX_WIDTH || collectionFilters.length <= 2;
            const categoryClassAttr = filter.filter_category_title.toLowerCase().replace(/\s+/g, '-');
            const isMobile = window.innerWidth <= 768;
            const nonArrowStyle = applySpliderArrow && !isMobile; 
            

            return `
              <div class="filter-section-container ${categoryClassAttr}" style="margin-bottom: 24px">
                <div class="filter-header_section">
                  <img class="filter-icon" src="${filter.icon}" width="18px" height="24px" alt="${filter.filter_category_title}">
                  <p class="filter-title">${filter.filter_category_title}</p>
                </div>

                <div style="display: flex;">
                    <div class="filter-arrow-left" style="display: ${applySpliderArrow ? "none" : "" }">
                        <svg style="transform: rotate(180deg)" aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-arrow-right  icon--direction-aware" viewBox="0 0 16 18">
                            <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
                        </svg>
                    </div>

                    <div class="splide filterSplide filter-wrapper" id="filterSplide-${categoryClassAttr}">
                        <div class="splide__track filter-links-carousel">
                            <ul class="splide__list filter_links" style="margin-left:${nonArrowStyle ? "29px !important" : "0px"}">
                            ${this.renderCollectionList(collectionFilters)}
                            </ul>
                        </div> 

                    <div class="filter-arrow" style="display: ${applySpliderArrow ? "none" : "" }"> 
                        <svg style="padding-top: 6px" aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-arrow-right  icon--direction-aware" viewBox="0 0 16 18">
                            <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
                        </svg>
                    </div>
                  </div>
                </div>

              </div>`;
          }).join("");

        this.innerHTML = content;
        this.AddFilterSlider()
    }

    AddFilterSlider() {
        const filterSections = document.querySelectorAll('.filter-section-container');
        filterSections.forEach((section) => {
            const arrowRigthEl = section.querySelector('.filter-arrow');
            const arrowLeftEl = section.querySelector('.filter-arrow-left');
            const splideEl = section.querySelector('.splide.filterSplide');          
            
            if(arrowRigthEl.style.display === "none" && arrowLeftEl.style.display === "none"){
                splideEl.classList.remove('splide');
                return;
            };

            const filterSlider = new Splide(splideEl, {
                type       : 'slide', 
                pagination : false,      
                arrows     : false, 
                breakpoints: {
                    768: { 
                        destroy: true
                    },  
                }  
            });
            
            filterSlider.mount();
            
            if(arrowRigthEl){
                arrowRigthEl.addEventListener('click', function(e) {
                    e.preventDefault();
                    filterSlider.go('>');
                });
            };

            if(arrowLeftEl){
                arrowLeftEl.addEventListener('click', function(e) {
                    e.preventDefault();
                    filterSlider.go('<');
                });
            }
        });
    };    
};

customElements.define('search-filter-category', SearchFilterCategory);


class SearchTrendingCategory extends HTMLElement {
    constructor(){
        super();
    };

    connectedCallback() {
        const trendingObj = window.search_trendingMetaObj;
        const sortedCategories = trendingObj.sort((a, b) =>{
            return a.category_order_position - b.category_order_position;
        })

        this.render(sortedCategories);
    }; 

    render(categories) {            
        const content = categories.map((category) => {
            return `
                <div class="featured-categories-container-search_list-card">
                    <img 
                        class="featured-categories-container-search_list-card-img" 
                        data-media-image="${ category.category_image }"
                        data-mobile-image="${ category.mobile_category_image }"
                        width="80px" 
                        height="80px" 
                        alt="${ category.category_title }">
              
                    <div class="featured-categories-container-search_list-card_info">
                        <h2 class="featured-categories-container-search_list-card-title">${ category.category_title }</h2>
                        <a href="${ category.collection_link }" class="featured-categories-container-search_list-card-arrow">
                            <svg aria-hidden="true" focusable="false" fill="none" width="20" class="icon icon-arrow-right  icon--direction-aware" viewBox="0 0 16 18">
                                <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
                            </svg>
                        </a>
                    </div>
                </div>`;
            }).join("");
  
          this.innerHTML = content;
      }
}; 


customElements.define('search-trending-category', SearchTrendingCategory);